export default __webpack_public_path__ + "static/media/Logo_lens-Barber-Shop-01.39de3cb1.png";